import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function postReportReturnLabelsFile(
  data: openapi.PostReportReturnLabels_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PostReportReturnLabels_200> {
  return await api.post<openapi.PostReportReturnLabels_200>(
    '/report/return-labels/',
    data,
    {
      ...requestConfig,
      responseType: 'blob',
    },
  );
}

export async function postReportReturnLabelsPrint(
  data: openapi.PostReportReturnLabelsPrint_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PostReportReturnLabelsPrint_200> {
  return await api.post<openapi.PostReportReturnLabelsPrint_200>(
    '/report/return-labels/print/',
    data,
    requestConfig,
  );
}
